import api from '../lib/api';

const API_URL = import.meta.env.VITE_APPOINTMENTS_API_URL;

// ---------------------------------------------------------------------
//  TYPES
// ---------------------------------------------------------------------
export interface AppointmentPayload {
  clientName: string;
  email: string;
  phone?: string;
  address?: string;
  clientCompany?: string;
  notes?: string;

  appointmentDate: string; // ISO
  slot?: string; // "09:30-10:00"
  slotId?: string; // optional override
  meetingLink?: string; // optional override
}

export interface AppointmentUpdatePayload extends AppointmentPayload {}

// ---------------------------------------------------------------------
//  MAIN SERVICE FUNCTIONS
// ---------------------------------------------------------------------

/**
 * Get all appointments for a company
 */
export async function fetchAppointments(company: string) {
  try {
    const res = await api.get(`${API_URL}/api/${company}/appointments`);
    return res.data;
  } catch (err) {
    console.error('Error fetching appointments:', err);
    throw err;
  }
}

/**
 * Create a new appointment
 */
export async function createAppointment(
  company: string,
  payload: AppointmentPayload,
) {
  try {
    const res = await api.post(
      `${API_URL}/api/${company}/appointments`,
      payload,
    );
    return res.data;
  } catch (err) {
    console.error('Error creating appointment:', err);
    throw err;
  }
}

/**
 * Update appointment (Admin full edit)
 */
export async function updateAppointment(
  company: string,
  id: string,
  payload: AppointmentUpdatePayload,
) {
  try {
    const res = await api.put(
      `${API_URL}/api/${company}/appointments/${id}`,
      payload,
    );
    return res.data;
  } catch (err) {
    console.error('Error updating appointment:', err);
    throw err;
  }
}

/**
 * Delete an appointment
 */
export async function deleteAppointment(company: string, id: string) {
  try {
    const res = await api.delete(
      `${API_URL}/api/${company}/appointments/${id}`,
    );
    return res.data;
  } catch (err) {
    console.error('Error deleting appointment:', err);
    throw err;
  }
}

/**
 * Join meeting using secure redirect token
 */
export async function joinMeeting(token: string) {
  try {
    const res = await api.get(`${API_URL}/api/join?token=${token}`, {
      maxRedirects: 0, // prevent browser auto-follow if desired
      validateStatus: () => true,
    });
    return res;
  } catch (err) {
    console.error('Error joining meeting:', err);
    throw err;
  }
}
